import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { SolvedProblemsModuleName } from '@/store/modules/modules'

export class SolvedProblemsViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelChartData: number[]; dailyTotalChartData: number[][]; maxTotal: number }> = computed(
    () => this.store.getters[`${SolvedProblemsModuleName}/chartData`]
  )
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${SolvedProblemsModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${SolvedProblemsModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${SolvedProblemsModuleName}/hasData`])

  setChartData(chartData: { labelChartData: number[]; dailyTotalChartData: number[][]; maxTotal: number }): void {
    this.store.commit(`${SolvedProblemsModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${SolvedProblemsModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${SolvedProblemsModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${SolvedProblemsModuleName}/setHasData`, hasData)
  }
}
